import React, { createContext, useState } from "react";

export const CurrentUserContext = createContext();

const UserContext = ({ children }) => {
  const loggedInUserData = JSON.parse(localStorage.getItem("userData"));

  const [userContextData, setUserContextData] = useState(
    loggedInUserData
      ? loggedInUserData
      : {
          isLoggedIn: false,
        }
  );

  const storeUserData = (userData) => {
    //Guardo los datos del usuario en userContextData
    setUserContextData(userData);
    //Guardo los datos del usuario en localStorage
    localStorage.setItem("userData", JSON.stringify(userData));
  };

  return (
    <>
      <CurrentUserContext.Provider value={[userContextData, storeUserData]}>
        {children}
      </CurrentUserContext.Provider>
    </>
  );
};

export default UserContext;
